import React from 'react';
import PropTypes from 'prop-types';

import InputString from './String';
import InputNumeric from './Numeric';
import InputSelect from './Select';
import InputBoolean from './Boolean';
import InputDate from './Date';
import InputAsync from './InputAsync';

function Input(props) {
  let { column } = props;
  column = column || {};
  let filterType = column.type;

  if (column.lookup && Object.keys(column.lookup).length)
    filterType = 'options';

  if (filterType === 'string')
    return <InputString {...props} />;

  if (filterType === 'numeric')
    return <InputNumeric {...props} />;

  if (filterType === 'options')
    return <InputSelect {...props} />;

  if (filterType === 'boolean')
    return <InputBoolean {...props} />;

  if (filterType === 'date' || filterType === 'datetime')
    return <InputDate {...props} />;

  if (filterType === 'currency')
    return <InputNumeric {...props} startAdornment={column.currencyCode || 'R$'} />;

  if (filterType === 'async')
    return <InputAsync {...props} asyncFetch={column.asyncFetch} asyncShow={column.asyncShow} />;

  return (
    <InputString
      {...props}
      inputProps={{
        disabled: true,
      }}
    />
  );
}

Input.defaultProps = {
  type: null,
};

Input.propTypes = {
  filter: PropTypes.shape({
    column: PropTypes.string.isRequired,
    operation: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.shape({
        id:   PropTypes.number,
        name: PropTypes.string,
      }),
    ]).isRequired,
  }).isRequired,
  indexGroup: PropTypes.number.isRequired,
  indexFilter: PropTypes.number.isRequired,
  column:  PropTypes.shape({
    title: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
      'boolean',
      'numeric',
      'date',
      'datetime',
      'currency',
      'string',
      'options',
      'async'
    ]).isRequired,
    lookup: PropTypes.object,
    precision: PropTypes.number,
    currencyCode: PropTypes.string,
    asyncFetch: PropTypes.func,
    asyncShow: PropTypes.func,
  }),
};

export default React.memo(Input);
